/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/tools/CropTool',['./Tool', '../shapes/CropShape'], function (Tool, CropShape) {
	'use strict';

	var CropTool = Tool.extend({

		crop: null, // CropShape instance

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init() {
			CropTool.inherited('init', this, arguments);
		},

		create: function create(canvas, xCoord, yCoord) {
			// crop tool needs a singleton shape
			if (this.crop) {
				this.crop.reset();
			}

			this.crop = new CropShape({
				canvas: canvas,
				xCoord: xCoord,
				yCoord: yCoord,
				borderColor: this.borderColor,
				fillColor: this.fillColor
			});
			return this.crop;
		},

		canUpdate: function canUpdate() {
			return false;
		},

		executeAction: function executeAction(action, canvas) {
			var result = false;

			canvas.isDrawingMode = false;
			canvas.mouseIsDown = false;
			canvas.keyPress = false;
			if (this.crop) {
				this.crop.reset();

				if (action === 'done') {
					var dimensions = this.crop.getDimensions();

					//set dimensions of new canvas after cropping
					canvas.setWidth(dimensions.width);
					canvas.setHeight(dimensions.height);
					if (canvas.backgroundImage) {
						canvas.backgroundImage.set({
							top: canvas.backgroundImage.top - dimensions.top,
							left: canvas.backgroundImage.left - dimensions.left
						});
					}
					//move all objects relative to new position
					canvas.getObjects().forEach(function (object) {
						object.set({
							top: object.top - dimensions.top,
							left: object.left - dimensions.left
						});
						object.setCoords();
					});
					result = true;
				}
				this.crop = null;
			}
			return result;
		}
	});

	return CropTool;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

